import { render, staticRenderFns } from "./MISPromoListComponent.vue?vue&type=template&id=19c52846"
import script from "./MISPromoListComponent.vue?vue&type=script&lang=js"
export * from "./MISPromoListComponent.vue?vue&type=script&lang=js"
import style0 from "./MISPromoListComponent.vue?vue&type=style&index=0&id=19c52846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports